"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputJsonValue = void 0;
const zod_1 = require("zod");
exports.InputJsonValue = zod_1.z.union([
    zod_1.z.string(),
    zod_1.z.number(),
    zod_1.z.boolean(),
    zod_1.z.lazy(() => zod_1.z.array(exports.InputJsonValue.nullable())),
    zod_1.z.lazy(() => zod_1.z.record(exports.InputJsonValue.nullable())),
]);
exports.default = exports.InputJsonValue;
//# sourceMappingURL=InputJsonValue.js.map